"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAFixPosition = void 0;
/**
 * The possible values of the IA fixPosition property.
 * A Seitenplatte can be placed on the left, on the right or on both sides.
 */
var IAFixPosition;
(function (IAFixPosition) {
    // BOTH = 0,
    IAFixPosition[IAFixPosition["ONLY_LEFT"] = 1] = "ONLY_LEFT";
    IAFixPosition[IAFixPosition["ONLY_RIGHT"] = 2] = "ONLY_RIGHT";
})(IAFixPosition = exports.IAFixPosition || (exports.IAFixPosition = {}));
//# sourceMappingURL=IAFixPositionEnum.js.map